import React from 'react';

export const GiftBoxIcon: React.FC = () => (
    <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        {/* Box body */}
        <rect x="8" y="30" width="48" height="28" rx="3" fill="none" stroke="#a3d232" strokeWidth="2" />
        {/* Lid */}
        <rect x="6" y="20" width="52" height="12" rx="3" fill="none" stroke="#a3d232" strokeWidth="2" />
        {/* Vertical ribbon on body */}
        <line x1="32" y1="32" x2="32" y2="58" stroke="#a3d232" strokeWidth="2" />
        {/* Horizontal ribbon on lid */}
        <line x1="6" y1="28" x2="58" y2="28" stroke="#0d0d0d" strokeWidth="2" />
        {/* Bow left loop */}
        <path
            d="M32 20 C24 10, 14 10, 16 18 C18 24, 28 22, 32 20Z"
            fill="none"
            stroke="#a3d232"
            strokeWidth="2"
        />
        {/* Bow right loop */}
        <path
            d="M32 20 C40 10, 50 10, 48 18 C46 24, 36 22, 32 20Z"
            fill="none"
            stroke="#a3d232"
            strokeWidth="2"
        />
        {/* Bow center knot */}
        <circle cx="32" cy="20" r="3" fill="#a3d232" />
    </svg>
);